import React from 'react';
import { trackPixelEvent } from '../utils/metaPixel';

/** Carrito de Shopify con 1 unidad de Pawsy Emprende (variante 49240627675387). */
export const CHECKOUT_URL = 'https://emprende.pawsycompanion.com/cart/49240627675387:1';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  variant?: 'gold' | 'petrol' | 'outline';
  size?: 'md' | 'lg';
  className?: string;
  /** Meta Pixel event fired on click. Purchase CTAs use 'InitiateCheckout'. */
  pixelEvent?: string;
};
const variants = {
  gold: 'bg-gold text-petrol-dark hover:bg-gold-dark',
  petrol: 'bg-petrol text-cream hover:bg-petrol-dark',
  outline: 'bg-transparent text-petrol border border-petrol/25 hover:border-petrol/60 hover:bg-petrol/5'
};
const sizes = {
  md: 'px-6 py-3.5 text-[15px]',
  lg: 'px-8 py-[18px] text-base sm:text-lg'
};
export function CtaButton({
  children,
  href = CHECKOUT_URL,
  variant = 'gold',
  size = 'md',
  className = '',
  pixelEvent = 'InitiateCheckout'
}: CtaButtonProps) {
  const isExternal = /^https?:\/\//.test(href);
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (pixelEvent) trackPixelEvent(pixelEvent);
    if (!isExternal) return;

    // Navigate explicitly so the checkout also opens when the page runs inside a frame.
    event.preventDefault();
    try {
      const target = window.top ?? window;
      target.location.href = href;
    } catch {
      window.location.href = href;
    }
  };
  return <a href={href} onClick={handleClick} className={`inline-flex items-center justify-center gap-2 rounded-full font-sans font-semibold shadow-card transition-[background-color,transform,box-shadow] duration-200 ease-soft hover:-translate-y-0.5 hover:shadow-lift active:translate-y-0 ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-24" data-mp="3ou7ei0aawknu">
      {children}
    </a>;
}